function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// scroll-watch
(function (window, factory) {
  // universal module definition

  /* globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['./core', 'fizzy-ui-utils/utils'], function (InfiniteScroll, utils) {
      return factory(window, InfiniteScroll, utils);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./core'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.InfiniteScroll, window.fizzyUIUtils);
  }
})(window, function factory(window, InfiniteScroll, utils) {
  var proto = InfiniteScroll.prototype; // default options

  InfiniteScroll.defaults.scrollThreshold = 400; // InfiniteScroll.defaults.elementScroll = null;

  InfiniteScroll.create.scrollWatch = function () {
    // events
    this.pageScrollHandler = this.onPageScroll.bind(this);
    this.resizeHandler = this.onResize.bind(this);
    var scrollThreshold = this.options.scrollThreshold;
    var isEnable = scrollThreshold || scrollThreshold === 0;

    if (isEnable) {
      this.enableScrollWatch();
    }
  };

  InfiniteScroll.destroy.scrollWatch = function () {
    this.disableScrollWatch();
  };

  proto.enableScrollWatch = function () {
    if (this.isScrollWatching) {
      return;
    }

    this.isScrollWatching = true;
    this.updateMeasurements();
    this.updateScroller(); // TODO disable after error?

    this.on('last', this.disableScrollWatch);
    this.bindScrollWatchEvents(true);
  };

  proto.disableScrollWatch = function () {
    if (!this.isScrollWatching) {
      return;
    }

    this.bindScrollWatchEvents(false);
    delete this.isScrollWatching;
  };

  proto.bindScrollWatchEvents = function (isBind) {
    var addRemove = isBind ? 'addEventListener' : 'removeEventListener';
    this.scroller[addRemove]('scroll', this.pageScrollHandler);
    window[addRemove]('resize', this.resizeHandler);
  };

  proto.onPageScroll = InfiniteScroll.throttle(function () {
    var distance = this.getBottomDistance();

    if (distance <= this.options.scrollThreshold) {
      this.dispatchEvent('scrollThreshold');
    }
  });

  proto.getBottomDistance = function () {
    if (this.options.elementScroll) {
      return this.getElementBottomDistance();
    } else {
      return this.getWindowBottomDistance();
    }
  };

  proto.getWindowBottomDistance = function () {
    var bottom = this.top + this.element.clientHeight;
    var scrollY = window.pageYOffset + this.windowHeight;
    return bottom - scrollY;
  };

  proto.getElementBottomDistance = function () {
    var bottom = this.scroller.scrollHeight;
    var scrollY = this.scroller.scrollTop + this.scroller.clientHeight;
    return bottom - scrollY;
  };

  proto.onResize = function () {
    this.updateMeasurements();
  };

  utils.debounceMethod(InfiniteScroll, 'onResize', 150); // --------------------------  -------------------------- //

  return InfiniteScroll;
});